module.exports = __webpack_public_path__ + "img/自主学习 1@2x.b7b8b240.png";